import { StaticCanvas } from 'fabric';
import { walkObjects } from '../../canvas/utils/walk-objects';
import { isSobreimpresoTextbox } from './types';
import { initSobreimpreso } from './init';

export function initAllSobreimpresos(canvas: StaticCanvas): void {
  walkObjects(canvas, obj => {
    if (isSobreimpresoTextbox(obj)) initSobreimpreso(obj);
  });
}
